export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'SET_STYLE': {
      return payload;
    }
    default:
      return state;
  }
};
